import React from 'react';
import Filters from '../Filters';
import PropTypes from 'prop-types';
import {Creatable} from 'react-select';

import 'react-select/dist/react-select.css';

export default class FilterMain extends Filters {
  static propTypes = {
    className: PropTypes.string,
    initialValues: PropTypes.obj,
    onChange: PropTypes.func,
    selected: PropTypes.array
  };

  render() {
    return (
      <Creatable
        className={this.props.className}
        name="custom-filter"
        multi
        value={this.props.selected}
        onChange={this.props.onChange}
        noResultsText={this.props.acceptedParams ? `Accepted params are: ${this.props.acceptedParams.join(', ')}` : 'Add Option'}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Filters/CustomFilterComponent/CustomFilter.js